import he from "he";
import { makeStyles } from "@material-ui/core";
import { Typography, Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import SubmitLoader from "src/components/SubmitLoader";
import {
  CancelButton,
  RdxAutocompleteField,
  RdxCheckBox,
  RdxTextField,
  SubmitButton,
} from "src/components/form/InputFields";
import { providers } from "src/mock/providers";
import { graph2 } from "src/mock/graph";
import * as yup from "yup";
import { renameKey } from "src/utils/changeKeyName";
import {
  setSMTUsage,
  setShowRateGraphInStore,
  setUsageInStore,
} from "src/slices/bkvReducer";
import { useDispatch, useSelector } from "src/store";
import {
  fetchAgreement,
  fetchSmtUsage,
  getAgreement,
  getNewAgreement,
  getProviders,
  updateCustomer,
} from "src/api/APIs";
import Notibar from "src/utils/Notibar";
import constants from "src/constants";
import SmtAgreementModal from "../UsageMethods/SmtAgreementModal";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import moment from "moment";

const validationSchema = yup.object().shape({
  meterNumber: yup.string().nullable().max(10).required(),
  address: yup.string().nullable().required(),
  email: yup.string().email().nullable().required(),
  consent: yup.boolean().nullable().oneOf([true]).required(),
});

const validate = (values) => {
  const formErrors = {};

  try {
    validationSchema.validateSync(values, { abortEarly: false });
  } catch (errors) {
    errors.inner.forEach((error) => {
      formErrors[error.path] = error.message;
    });
  }

  return formErrors;
};

let SmtForm = (props) => {
  const classes = useStyles();
  const { handleSubmit, pristine, handleClose, changeView, email } = props;
  const [submitting, setSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [providerList, setProviderList] = useState([]);
  const [showResponsiveDiv, setShowResponseDiv] = useState(false);
  const [agreement, setAgreement] = useState();
  const [confirmUrl, setConfirmUrl] = useState();
  const [consentId, setConsentId] = useState();
  const [selectedProvider, setSelectedProvider] = useState<any>({});
  const agreementContent = useRef<HTMLDivElement>(null);
  const [meterNumber, setMeterNumber] = useState();
  const [inputEmail, setInputEmail] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.bkv);
  const [showAgreement, setShowAgreement] = useState(false);
  const [smtStates, setSmtStates] = useState({
    agreement: null,
    url: null,
    email: null,
    consent_id: null,
  });

  const createMarkup = () => {
    let html = "";
    if (agreement) {
      html = he.decode(agreement);
      html = html.replace(
        /<i>ACTION REQUIRED:/,
        '<i id="action-required">ACTION REQUIRED:'
      );
      html = html.replace(/<html><body>/, "").replace(/<\/body><\/html>/, "");
    }
    return { __html: html };
  };

  const onSubmit = async (values) => {
    setSubmitting(true);
    let newAgreementres;
    updateCustomer({
      email: values.email,
      provider: selectedProvider["label"],
      sent_agreement: values.copy ? 1 : 0,
    });
    newAgreementres = getNewAgreement(
      state.address.esiid,
      values.meterNumber,
      selectedProvider?.certificate_number,
      values.email,
      values.copy ? 1 : 0
    )
      .then(async (res) => {
        if (res.data?.["response"]?.["consent_id"]) {
          // await callGetAgreement(res.data.response.consent_id);
          setConsentId(res.data.response.consent_id);
        } else if (res.data["message"]) {
          Notibar.toast(res.data.message);
          setSubmitting(false);
        } else {
          Notibar.error(
            "Failed to get SMT usage!! Please try a different method."
          );
          setSubmitting(false);
          handleClose("usageModal");
        }
      })
      .catch((error) => {
        Notibar.error(error);
        setSubmitting(false);
        handleClose("usageModal");
      });

    // setUsage(graph2);
  };

  // const callGetAgreement = async (consent_id) => {
  //   await getAgreement(consent_id).then((resp) => {
  //     if (resp?.data?.status === "New") {
  //       callGetAgreement(consent_id);
  //     } else if (resp?.data?.status === "Waiting for approval") {
  //       setAgreement(resp?.data?.response?.form_content);
  //       setSmtStates({
  //         agreement: resp.data.response.form_content,
  //         url: resp.data.response.agree_btn_url,
  //         email: email,
  //         consent_id: resp.data.response.consent_id,
  //       });
  //       setShowResponseDiv(true);
  //       setSubmitting(false);
  //     } else if (resp?.data?.status === "Approved") {
  //       setSubmitting(false);
  //     } else {
  //       Notibar.error("Failed to fetch usage!! unknown response status.");
  //     }
  //   });
  // };

  useEffect(() => {
    if (consentId && !agreement) {
      handleCheckAgreement("get");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consentId, agreement]);

  const handleCheckAgreement = (type: string) => {
    setSubmitting(true);
    try {
      fetchAgreement(consentId).then((res) => {
        if (res) {
          if (res.error_code && res.error_code === "500") {
            setSubmitting(false);
            Notibar.error(res.message);
            // console.error(res.message);
            handleBack();
            return;
          }
          const status = res.status.toLowerCase();
  
          if (status === "new") {
            setTimeout(() => {
              handleCheckAgreement("get");
            }, 2000);
          }
          if (status === "waiting for approval") {
            if (type === "get") {
              setShowAgreement(true);
              setAgreement(res.response.form_content);
              setConfirmUrl(res.response.agree_btn_url);
              setSubmitting(false);
              setSmtStates({
                agreement: res.response.form_content,
                url: res.response.agree_btn_url,
                email: email,
                consent_id: res.response.consent_id,
              });
              setShowResponseDiv(true);
            } else {
              // type: confirm
              setTimeout(() => {
                handleCheckAgreement("confirm");
              }, 2000);
            }
          }
          if (status === "approved") {
            getMonthlyUsage();
            setSubmitting(false);
            setShowResponseDiv(true);
          }
        } else {
          setSubmitting(false);
          console.log("error: get agreement");
        }
      });
    }catch {
      Notibar.error('SMT is down at the moment, please try again later.');
    }


  };

  const getMonthlyUsage = async () => {
    try {
      const startDate = moment().subtract(1, "years").format("MM/DD/YYYY");
      const endDate = moment().subtract(1, "days").format("MM/DD/YYYY");
      const esiid = state.address.esiid;
      fetchSmtUsage(esiid, consentId, startDate, endDate).then(async (res) => {
        if (res) {
          // console.log("res", res);
          dispatch(
            setSMTUsage(res, () => {
              handleUsage();
            })
          );
        }
      });
    } catch (e) {
      Notibar.error('SMT is down at the moment, please try again later.');
    }
  };

  const handleUsage = async () => {
    dispatch(setShowRateGraphInStore(false));
    setSubmitting(false);
    handleClose("usageModal");
  };

  const handleBack = () => {
    changeView("options");
  };

  const handleOnBack = () => {
    changeView("smt");
  };

  useEffect(() => {
    getProviders().then((res: any) => {
      let list = renameKey(res.data, "business_name", "label");
      // console.log(list, "list>>>>");
      setProviderList(list);
    });
  }, []);

  useEffect(() => {
    const confirmSmtRequest = (link) => {
      window.open(link, "_blank");
      handleCheckAgreement("confirm");
      // setShowConfirmModal(true);
    };

    const rejectSmtRequest = () => {
      Notibar.toast("navigate('/retrieve-usage')");
    };

    const openLink = () => {
      // window.open("about:blank");
      // if (w) w.location.href = link;
    };
    const agreementListener = (evt: any) => {
      evt.preventDefault();
      evt.stopPropagation();

      let link = "";
      let btnText = "";
      const target = evt.target;
      if (
        target.tagName.toLowerCase() === "b" &&
        target.parentNode.tagName.toLowerCase() === "a"
      ) {
        link = target.parentNode.href;
        btnText = target.innerText.toLowerCase();
      } else if (target.tagName.toLowerCase() === "a") {
        link = target.href;
        btnText = target.innerText.toLowerCase();
      }
      if (link && btnText) {
        switch (btnText) {
          case "confirm":
            confirmSmtRequest(link);
            break;
          case "do not confirm":
            rejectSmtRequest();
            break;
          case "did not request":
            rejectSmtRequest();
            break;
          default:
            openLink();
        }
      }
    };

    if (agreementContent && agreementContent.current) {
      const current = agreementContent.current;
      document.getElementById("action-required").scrollIntoView({
        block: "center",
      });
      current.addEventListener("click", agreementListener);
      return () => {
        if (agreementContent && current) {
          current.removeEventListener("click", agreementListener);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agreement]);

  const handleFormChange = (val) =>{
    if (val.name === 'email') {
      setInputEmail(val.value);
    }else if (val.name === 'meterNumber') {
      setMeterNumber(val.value);
    }
  }
  const isEmptyObject =(obj: object)=> {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  return (
    <div>
      {!showResponsiveDiv && (
        <form onSubmit={handleSubmit(onSubmit)} onChange={(e)=>{handleFormChange(e.target)}}>
          <Box className={classes.root}>
            <>
              <Typography
                align="center"
                variant="body2"
                fontSize={{
                  xs: "3.8vw",
                  sm: "3.8vw",
                  md: "3.3vw",
                  lg: "25px",
                }}
              >
                We are almost there!
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "2.5vw",
                    sm: "2.5vw",
                    md: "2.5vw",
                    lg: "1.3vw",
                  },
                  marginTop: "3%",
                  color: "#595959",
                }}
                align="center"
              >
                To ensure the accuracy of the data, we will need your Smart
                Meter Texas (SMT) number and the permission to access the data
              </Typography>

              <Field
                name="address"
                width={100}
                label="Provider"
                placeholder="Select..."
                component={RdxAutocompleteField}
                options={providerList}
                setDetails={(details) => setSelectedProvider(details)}
                style={{
                  background: "rgb(237 237 237)",
                  borderRadius: "10vw",
                }}
              />
              {/* <Field
          name="address"
          width={100}
          label="Address"
          placeholder="Type your Address"
          component={RdxAutocompleteField}
          options={data}
        /> */}
              <Box sx={{ position: "relative" }}>
                <Field
                  name="meterNumber"
                  width={100}
                  label="Meter Number"
                  placeholder="Type your Meter Number"
                  component={RdxTextField}
                  style={{ background: "rgb(237 237 237)" }}
                />
                <Tooltip
                  className={classes.tooltip}
                  title="You can check for your meter number on your bill."
                  placement="top"
                >
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Box>

              <Field
                name="email"
                width={100}
                label="E-mail"
                placeholder="Type your E-mail"
                component={RdxTextField}
                style={{ background: "rgb(237 237 237)" }}
              />
              <Box className={classes.consents}>
                <Field name="copy" component={RdxCheckBox}>
                  Would you like to receive a copy of the consent?
                </Field>
                <Field name="consent" component={RdxCheckBox}>
                  By checking the box, I agree to grant BKV Energy permission to
                  access my account on Smart Meter Texas (SMT). In addition, BKV
                  Energy shall provide all SMT e-mail communications received by
                  BKV Energy on your behalf to your e-mail address provided.
                </Field>
              </Box>
              <Box className={classes.buttonBox}>
                <CancelButton onClick={handleBack} disabled={submitting}>
                  Back
                </CancelButton>
                <SubmitButton type="submit" disabled={!inputEmail|| isEmptyObject(selectedProvider) || !meterNumber||  pristine || submitting}>
                  Continue
                </SubmitButton>
              </Box>
            </>
          </Box>
          <SubmitLoader open={submitting} />
        </form>
      )}

      <Box className={classes.root}>
        {agreement && (
          <div
            id="agreement-wrapper"
            dangerouslySetInnerHTML={createMarkup()}
            ref={agreementContent}
            style={{ opacity: submitting ? 0 : 1 }}
          />
        )}
        <SmtAgreementModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          url={smtStates.url}
          consentId={smtStates.consent_id}
          callback={handleUsage}
        />
      </Box>
    </div>
  );
};

SmtForm = reduxForm({
  form: "SmtForm",
  validate,
  initialValues: {
    consent: false,
  },
})(SmtForm);
const selector = formValueSelector("SmtForm");
SmtForm = connect((state) => {
  const email = selector(state, "consent");
  return {
    email,
  };
})(SmtForm);

export default SmtForm;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2% 5%",
    maxWidth: 757,
    backgroundColor: "#fff",
    position: "relative",
  },
  consents: {
    marginTop: 24,
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  buttonBox: {
    marginTop: 50,
    display: "flex",
    gap: 30,
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
  },
  tooltip: {
    position: "absolute",
    top: "9%",
    left: "19%",
  },
}));
